import Navbar from './Navbar';
import SiteRoutes from './SiteRoutes';
import './App.css';
import React, { useState, createContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Cookies from 'js-cookie';


export const AppContext = createContext(null)

const loadState = (key, defaultValue) => {
  const savedState = localStorage.getItem(key);
  return savedState ? JSON.parse(savedState) : defaultValue;
};

function App() {

  const [user, setUser] = useState(() => {
    const savedUser = Cookies.get('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [isLogged, setIsLogged] = useState(() => {
    const loggedStatus = Cookies.get('isLogged');
    return loggedStatus === 'true'; // Cookies store everything as strings
  });

  const location = useLocation();

  const hideNavbarRoutes = [
    "/invitation/general/:slug",
    "/invite/:invitation_token/gift",
    "/gift/thank-you",
    "/invitation/confirm/:uuid",
    "/invitation/confirm/en/:uuid",
    "/invitation/confirm/fr/:uuid",
    "/invitation/confirm/he/:uuid",
  ];
  
  const shouldHideNavbar = hideNavbarRoutes.some((route) => {
    const pattern = "^" + route.replace(/:[^/]+/g, "[^/]+") + "/?$";
    return new RegExp(pattern).test(location.pathname);
  });  

  
  return (
    <div className="App">
      <AppContext.Provider value={{ user, setUser, isLogged, setIsLogged }}>
      {!shouldHideNavbar && <Navbar />}
      <div>
        <SiteRoutes />
      </div>
      </AppContext.Provider>
    </div>
  );
}

export default App;
